<template lang="pug">
  b-modal#updateBLSB(
    ref="updateBLSB"
    :title="$t('ui.combine.update_bet_limit')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="lg"
    @ok="done"
    @show="reset"
    @shown="shown"
    :hide-footer="!$helpers.getVisible(editLimit)"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      span #[b {{ $t("ui.account_id") + " : " + accountId.toUpperCase() }}]
      #tblModal.table-sm.table-responsive.betLimit
        table.table.table-bordered
          thead
            tr
              th &nbsp;
              th.text-center(style="width:20%;")
                small.text-warning {{ $t("ui.copy_to_bottom") }}
                b-form-checkbox(
                  size="sm"
                  v-model="copyAllMin"
                  :title="$helpers.copyAllMinBet_title()"
                  @input="toggleAll()"
                  plain
                  :disabled="!$helpers.getVisible(editLimit)"
                ) {{ $t("ui.min_bet") }}
              th.text-center(style="width:20%;")
                small.text-warning {{ $t("ui.copy_to_bottom") }}
                b-form-checkbox(
                  size="sm"
                  v-model="copyAllMax"
                  :title="$helpers.copyAllMaxBet_title()"
                  @input="toggleAll()"
                  plain
                  :disabled="!$helpers.getVisible(editLimit)"
                ) {{ $t("ui.max_bet") }}
              th.text-center(style="width:20%;")
                small.text-warning {{ $t("ui.copy_to_bottom") }}
                b-form-checkbox(
                  size="sm"
                  v-model="copyAllMaxPerMatch"
                  :title="$helpers.copyAllMaxPerMatch_title()"
                  @input="toggleAll()"
                  plain
                  :disabled="!$helpers.getVisible(editLimit)"
                ) {{ $t("ui.max_per_match") }}
          tbody(v-if="$store.getters.getBetLimit")
            tr
              th {{ $t("ui.soccer") }}
              td
                MoneyInput(
                  ref="soccer_min_bet"
                  :dirty="$v.soccer_min_bet.$dirty"
                  :error="$v.soccer_min_bet.$error"
                  :minValue="$v.soccer_min_bet.$params.minValue.min"
                  :maxValue="$v.soccer_min_bet.$params.maxValue.max"
                  v-model="$v.soccer_min_bet.$model"
                  :value="soccer_min_bet"
                  @input="input_soccer_min_bet"
                  :title="soccer_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="soccer_max_bet"
                  :dirty="$v.soccer_max_bet.$dirty"
                  :error="$v.soccer_max_bet.$error"
                  :minValue="$v.soccer_max_bet.$params.minValue.min"
                  :maxValue="$v.soccer_max_bet.$params.maxValue.max"
                  :value="soccer_max_bet"
                  @input="input_soccer_max_bet"
                  :title="soccer_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="soccer_max_per_match"
                  :dirty="$v.soccer_max_per_match.$dirty"
                  :error="$v.soccer_max_per_match.$error"
                  :minValue="$v.soccer_max_per_match.$params.minValue.min"
                  :maxValue="$v.soccer_max_per_match.$params.maxValue.max"
                  :value="soccer_max_per_match"
                  @input="input_soccer_max_per_match"
                  :title="soccer_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ $t("ui.basketball") }}
              td
                MoneyInput(
                  ref="basketball_min_bet"
                  :dirty="$v.basketball_min_bet.$dirty"
                  :error="$v.basketball_min_bet.$error"
                  :minValue="$v.basketball_min_bet.$params.minValue.min"
                  :maxValue="$v.basketball_min_bet.$params.maxValue.max"
                  v-model="$v.basketball_min_bet.$model"
                  :title="basketball_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="basketball_max_bet"
                  :dirty="$v.basketball_max_bet.$dirty"
                  :error="$v.basketball_max_bet.$error"
                  :minValue="$v.basketball_max_bet.$params.minValue.min"
                  :maxValue="$v.basketball_max_bet.$params.maxValue.max"
                  v-model="$v.basketball_max_bet.$model"
                  :title="basketball_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="basketball_max_per_match"
                  :dirty="$v.basketball_max_per_match.$dirty"
                  :error="$v.basketball_max_per_match.$error"
                  :minValue="$v.basketball_max_per_match.$params.minValue.min"
                  :maxValue="$v.basketball_max_per_match.$params.maxValue.max"
                  v-model="$v.basketball_max_per_match.$model"
                  :title="basketball_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ $t("ui.tennis") }}
              td
                MoneyInput(
                  ref="tennis_min_bet"
                  :dirty="$v.tennis_min_bet.$dirty"
                  :error="$v.tennis_min_bet.$error"
                  :minValue="$v.tennis_min_bet.$params.minValue.min"
                  :maxValue="$v.tennis_min_bet.$params.maxValue.max"
                  v-model="$v.tennis_min_bet.$model"
                  :title="tennis_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="tennis_max_bet"
                  :dirty="$v.tennis_max_bet.$dirty"
                  :error="$v.tennis_max_bet.$error"
                  :minValue="$v.tennis_max_bet.$params.minValue.min"
                  :maxValue="$v.tennis_max_bet.$params.maxValue.max"
                  v-model="$v.tennis_max_bet.$model"
                  :title="tennis_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="tennis_max_per_match"
                  :dirty="$v.tennis_max_per_match.$dirty"
                  :error="$v.tennis_max_per_match.$error"
                  :minValue="$v.tennis_max_per_match.$params.minValue.min"
                  :maxValue="$v.tennis_max_per_match.$params.maxValue.max"
                  v-model="$v.tennis_max_per_match.$model"
                  :title="tennis_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ $t("ui.baseball") }}
              td
                MoneyInput(
                  ref="baseball_min_bet"
                  :dirty="$v.baseball_min_bet.$dirty"
                  :error="$v.baseball_min_bet.$error"
                  :minValue="$v.baseball_min_bet.$params.minValue.min"
                  :maxValue="$v.baseball_min_bet.$params.maxValue.max"
                  v-model="$v.baseball_min_bet.$model"
                  :title="baseball_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="baseball_max_bet"
                  :dirty="$v.baseball_max_bet.$dirty"
                  :error="$v.baseball_max_bet.$error"
                  :minValue="$v.baseball_max_bet.$params.minValue.min"
                  :maxValue="$v.baseball_max_bet.$params.maxValue.max"
                  v-model="$v.baseball_max_bet.$model"
                  :title="baseball_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="baseball_max_per_match"
                  :dirty="$v.baseball_max_per_match.$dirty"
                  :error="$v.baseball_max_per_match.$error"
                  :minValue="$v.baseball_max_per_match.$params.minValue.min"
                  :maxValue="$v.baseball_max_per_match.$params.maxValue.max"
                  v-model="$v.baseball_max_per_match.$model"
                  :title="baseball_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ $t("ui.parlay") }}
              td
                MoneyInput(
                  ref="parlay_min_bet"
                  :dirty="$v.parlay_min_bet.$dirty"
                  :error="$v.parlay_min_bet.$error"
                  :minValue="$v.parlay_min_bet.$params.minValue.min"
                  :maxValue="$v.parlay_min_bet.$params.maxValue.max"
                  v-model="$v.parlay_min_bet.$model"
                  :title="parlay_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="parlay_max_bet"
                  :dirty="$v.parlay_max_bet.$dirty"
                  :error="$v.parlay_max_bet.$error"
                  :minValue="$v.parlay_max_bet.$params.minValue.min"
                  :maxValue="$v.parlay_max_bet.$params.maxValue.max"
                  v-model="$v.parlay_max_bet.$model"
                  :title="parlay_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="parlay_max_per_match"
                  :dirty="$v.parlay_max_per_match.$dirty"
                  :error="$v.parlay_max_per_match.$error"
                  :minValue="$v.parlay_max_per_match.$params.minValue.min"
                  :maxValue="$v.parlay_max_per_match.$params.maxValue.max"
                  v-model="$v.parlay_max_per_match.$model"
                  :title="parlay_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ $t("ui.esports") }}
              td
                MoneyInput(
                  ref="esports_min_bet"
                  :dirty="$v.esports_min_bet.$dirty"
                  :error="$v.esports_min_bet.$error"
                  :minValue="$v.esports_min_bet.$params.minValue.min"
                  :maxValue="$v.esports_min_bet.$params.maxValue.max"
                  v-model="$v.esports_min_bet.$model"
                  :title="esports_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="esports_max_bet"
                  :dirty="$v.esports_max_bet.$dirty"
                  :error="$v.esports_max_bet.$error"
                  :minValue="$v.esports_max_bet.$params.minValue.min"
                  :maxValue="$v.esports_max_bet.$params.maxValue.max"
                  v-model="$v.esports_max_bet.$model"
                  :title="esports_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="esports_max_per_match"
                  :dirty="$v.esports_max_per_match.$dirty"
                  :error="$v.esports_max_per_match.$error"
                  :minValue="$v.esports_max_per_match.$params.minValue.min"
                  :maxValue="$v.esports_max_per_match.$params.maxValue.max"
                  v-model="$v.esports_max_per_match.$model"
                  :title="esports_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ $t("ui.others_sports") }}
              td
                MoneyInput(
                  ref="others_min_bet"
                  :dirty="$v.others_min_bet.$dirty"
                  :error="$v.others_min_bet.$error"
                  :minValue="$v.others_min_bet.$params.minValue.min"
                  :maxValue="$v.others_min_bet.$params.maxValue.max"
                  v-model="$v.others_min_bet.$model"
                  :title="others_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="others_max_bet"
                  :dirty="$v.others_max_bet.$dirty"
                  :error="$v.others_max_bet.$error"
                  :minValue="$v.others_max_bet.$params.minValue.min"
                  :maxValue="$v.others_max_bet.$params.maxValue.max"
                  v-model="$v.others_max_bet.$model"
                  :title="others_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="others_max_per_match"
                  :dirty="$v.others_max_per_match.$dirty"
                  :error="$v.others_max_per_match.$error"
                  :minValue="$v.others_max_per_match.$params.minValue.min"
                  :maxValue="$v.others_max_per_match.$params.maxValue.max"
                  v-model="$v.others_max_per_match.$model"
                  :title="others_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
            tr
              th {{ $t("ui.correct_score") }} ({{ $t("ui.soccer") }})
              td
                MoneyInput(
                  ref="cs_min_bet"
                  :dirty="$v.cs_min_bet.$dirty"
                  :error="$v.cs_min_bet.$error"
                  :minValue="$v.cs_min_bet.$params.minValue.min"
                  :maxValue="$v.cs_min_bet.$params.maxValue.max"
                  v-model="$v.cs_min_bet.$model"
                  :title="cs_min_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="cs_max_bet"
                  :dirty="$v.cs_max_bet.$dirty"
                  :error="$v.cs_max_bet.$error"
                  :minValue="$v.cs_max_bet.$params.minValue.min"
                  :maxValue="$v.cs_max_bet.$params.maxValue.max"
                  v-model="$v.cs_max_bet.$model"
                  :title="cs_max_bet_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
              td
                MoneyInput(
                  ref="cs_max_per_match"
                  :dirty="$v.cs_max_per_match.$dirty"
                  :error="$v.cs_max_per_match.$error"
                  :minValue="$v.cs_max_per_match.$params.minValue.min"
                  :maxValue="$v.cs_max_per_match.$params.maxValue.max"
                  v-model="$v.cs_max_per_match.$model"
                  :title="cs_max_per_match_title"
                  :disabled="!$helpers.getVisible(editLimit)"
                )
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import config from "@/config";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import CommInput from "@/library/CommInput";
import MoneyInput from "@/library/MoneyInput2";

export default {
  components: {
    CommInput,
    MoneyInput,
    SubmitButton
  },
  props: {
    accountId: ""
  },
  data() {
    return {
      copyAllMin: false,
      copyAllMax: false,
      copyAllMaxPerMatch: false,
      loading: false,
      soccer_min_bet: "0",
      soccer_max_bet: "0",
      soccer_max_per_match: "0",
      basketball_min_bet: "0",
      basketball_max_bet: "0",
      basketball_max_per_match: "0",
      tennis_min_bet: "0",
      tennis_max_bet: "0",
      tennis_max_per_match: "0",
      baseball_min_bet: "0",
      baseball_max_bet: "0",
      baseball_max_per_match: "0",
      parlay_min_bet: "0",
      parlay_max_bet: "0",
      parlay_max_per_match: "0",
      esports_min_bet: "0",
      esports_max_bet: "0",
      esports_max_per_match: "0",
      others_min_bet: "0",
      others_max_bet: "0",
      others_max_per_match: "0",
      cs_min_bet: "0",
      cs_max_bet: "0",
      cs_max_per_match: "0",
      blJSON: {
        soccer_min_bet: 0,
        soccer_max_bet: 0,
        soccer_max_per_match: 0,
        basketball_min_bet: 0,
        basketball_max_bet: 0,
        basketball_max_per_match: 0,
        tennis_min_bet: 0,
        tennis_max_bet: 0,
        tennis_max_per_match: 0,
        baseball_min_bet: 0,
        baseball_max_bet: 0,
        baseball_max_per_match: 0,
        parlay_min_bet: 0,
        parlay_max_bet: 0,
        parlay_max_per_match: 0,
        esports_min_bet: 0,
        esports_max_bet: 0,
        esports_max_per_match: 0,
        others_min_bet: 0,
        others_max_bet: 0,
        others_max_per_match: 0,
        cs_min_bet: 0,
        cs_max_bet: 0,
        cs_max_per_match: 0,
      },
      submission: {
        success: true,
        status: ""
      },
      cs_min_bet_title: "",
      cs_max_bet_title: "",
      cs_max_per_match_title: ""
    }
  },
  validations: {
    soccer_min_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[6].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.soccer_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    soccer_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[6].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.soccer_max_per_match))(this.$helpers.convertNumber(value))
      }
    },
    soccer_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[6].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$store.getters.getBetLimit[6].max_per_match)(this.$helpers.convertNumber(value))
      }
    },
    basketball_min_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[1].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.basketball_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    basketball_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[1].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.basketball_max_per_match))(this.$helpers.convertNumber(value))
      }
    },
    basketball_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[1].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$store.getters.getBetLimit[1].max_per_match)(this.$helpers.convertNumber(value))
      }
    },
    tennis_min_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[7].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.tennis_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    tennis_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[7].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.tennis_max_per_match))(this.$helpers.convertNumber(value))
      }
    },
    tennis_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[7].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$store.getters.getBetLimit[7].max_per_match)(this.$helpers.convertNumber(value))
      }
    },
    baseball_min_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[0].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.baseball_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    baseball_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[0].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.baseball_max_per_match))(this.$helpers.convertNumber(value))
      }
    },
    baseball_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[0].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$store.getters.getBetLimit[0].max_per_match)(this.$helpers.convertNumber(value))
      }
    },
    parlay_min_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[5].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.parlay_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    parlay_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[5].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.parlay_max_per_match))(this.$helpers.convertNumber(value))
      }
    },
    parlay_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[5].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$store.getters.getBetLimit[5].max_per_match)(this.$helpers.convertNumber(value))
      }
    },
    esports_min_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[3].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.esports_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    esports_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[3].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.esports_max_per_match))(this.$helpers.convertNumber(value))
      }
    },
    esports_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[3].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$store.getters.getBetLimit[3].max_per_match)(this.$helpers.convertNumber(value))
      }
    },
    others_min_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[4].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.others_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    others_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[4].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.others_max_per_match))(this.$helpers.convertNumber(value))
      }
    },
    others_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$store.getters.getBetLimit[4].min_bet)(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        return maxValue(this.$store.getters.getBetLimit[4].max_per_match)(this.$helpers.convertNumber(value))
      }
    },
    cs_min_bet: {
      required,
      minValue(value) {
        if (this.$helpers.convertNumber(this.soccer_min_bet) > this.$store.getters.getBetLimit[2].min_bet) {
          return minValue(this.$helpers.convertNumber(this.soccer_min_bet))(this.$helpers.convertNumber(value))
        } else {
          return minValue(this.$store.getters.getBetLimit[2].min_bet)(this.$helpers.convertNumber(value))
        }
      },
      maxValue(value) {
        return maxValue(this.$helpers.convertNumber(this.cs_max_bet))(this.$helpers.convertNumber(value))
      }
    },
    cs_max_bet: {
      required,
      minValue(value) {
        return minValue(this.$helpers.convertNumber(this.cs_min_bet))(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        if (this.$helpers.convertNumber(this.soccer_max_bet) < this.$store.getters.getBetLimit[2].max_bet) {
          return maxValue(this.$helpers.convertNumber(this.soccer_max_bet))(this.$helpers.convertNumber(value))
        } else {
          return maxValue(this.$store.getters.getBetLimit[2].max_bet)(this.$helpers.convertNumber(value))
        }
      }
    },
    cs_max_per_match: {
      required,
      minValue(value) {
        return minValue(this.$helpers.convertNumber(this.cs_max_bet))(this.$helpers.convertNumber(value))
      },
      maxValue(value) {
        if (this.$helpers.convertNumber(this.soccer_max_per_match) < this.$store.getters.getBetLimit[2].max_per_match) {
          return maxValue(this.$helpers.convertNumber(this.soccer_max_per_match))(this.$helpers.convertNumber(value))
        } else {
          return maxValue(this.$store.getters.getBetLimit[2].max_per_match)(this.$helpers.convertNumber(value))
        }
      }
    },
  },
  computed: {
    editLimit() {
      return [config.accessRoles.editLimit]
    },
    soccer_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[6].min_bet
    },
    soccer_min_bet_title: function() {
      return this.$t('ui.min_bet') + ' >= ' + this.soccer_min_bet_amount
    },
    soccer_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[6].max_bet
    },
    soccer_max_bet_title: function() {
      return this.$t('ui.max_bet') + ' <= ' + this.soccer_max_bet_amount
    },
    soccer_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[6].max_per_match
    },
    soccer_max_per_match_title: function() {
      return this.$t('ui.max_per_match') + ' <= ' + this.soccer_max_per_match_amount
    },
    basketball_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[1].min_bet
    },
    basketball_min_bet_title: function() {
      return this.$t('ui.min_bet') + ' >= ' + this.basketball_min_bet_amount
    },
    basketball_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[1].max_bet
    },
    basketball_max_bet_title: function() {
      return this.$t('ui.max_bet') + ' <= ' + this.basketball_max_bet_amount
    },
    basketball_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[1].max_per_match
    },
    basketball_max_per_match_title: function() {
      return this.$t('ui.max_per_match') + ' <= ' + this.basketball_max_per_match_amount
    },
    tennis_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[7].min_bet
    },
    tennis_min_bet_title: function() {
      return this.$t('ui.min_bet') + ' >= ' + this.tennis_min_bet_amount
    },
    tennis_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[7].max_bet
    },
    tennis_max_bet_title: function() {
      return this.$t('ui.max_bet') + ' <= ' + this.tennis_max_bet_amount
    },
    tennis_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[7].max_per_match
    },
    tennis_max_per_match_title: function() {
      return this.$t('ui.max_per_match') + ' <= ' + this.tennis_max_per_match_amount
    },
    baseball_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[0].min_bet
    },
    baseball_min_bet_title: function() {
      return this.$t('ui.min_bet') + ' >= ' + this.baseball_min_bet_amount
    },
    baseball_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[0].max_bet
    },
    baseball_max_bet_title: function() {
      return this.$t('ui.max_bet') + ' <= ' + this.baseball_max_bet_amount
    },
    baseball_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[0].max_per_match
    },
    baseball_max_per_match_title: function() {
      return this.$t('ui.max_per_match') + ' <= ' + this.baseball_max_per_match_amount
    },
    parlay_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[5].min_bet
    },
    parlay_min_bet_title: function() {
      return this.$t('ui.min_bet') + ' >= ' + this.parlay_min_bet_amount
    },
    parlay_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[5].max_bet
    },
    parlay_max_bet_title: function() {
      return this.$t('ui.max_bet') + ' <= ' + this.parlay_max_bet_amount
    },
    parlay_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[5].max_per_match
    },
    parlay_max_per_match_title: function() {
      return this.$t('ui.max_per_match') + ' <= ' + this.parlay_max_per_match_amount
    },
    esports_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[3].min_bet
    },
    esports_min_bet_title: function() {
      return this.$t('ui.min_bet') + ' >= ' + this.esports_min_bet_amount
    },
    esports_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[3].max_bet
    },
    esports_max_bet_title: function() {
      return this.$t('ui.max_bet') + ' <= ' + this.esports_max_bet_amount
    },
    esports_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[3].max_per_match
    },
    esports_max_per_match_title: function() {
      return this.$t('ui.max_per_match') + ' <= ' + this.esports_max_per_match_amount
    },
    others_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[4].min_bet
    },
    others_min_bet_title: function() {
      return this.$t('ui.min_bet') + ' >= ' + this.others_min_bet_amount
    },
    others_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[4].max_bet
    },
    others_max_bet_title: function() {
      return this.$t('ui.max_bet') + ' <= ' + this.others_max_bet_amount
    },
    others_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[4].max_per_match
    },
    others_max_per_match_title: function() {
      return this.$t('ui.max_per_match') + ' <= ' + this.others_max_per_match_amount
    },
    cs_min_bet_amount: function() {
      return this.$store.getters.getBetLimit[2].min_bet
    },
    // cs_min_bet_title: function() {
    //   return this.$t('ui.min_bet') + ' >= ' + this.cs_min_bet_amount
    // },
    cs_max_bet_amount: function() {
      return this.$store.getters.getBetLimit[2].max_bet
    },
    // cs_max_bet_title: function() {
    //   return this.$t('ui.max_bet') + ' <= ' + this.cs_max_bet_amount
    // },
    cs_max_per_match_amount: function() {
      return this.$store.getters.getBetLimit[2].max_per_match
    },
    // cs_max_per_match_title: function() {
    //   return this.$t('ui.max_per_match') + ' <= ' + this.cs_max_per_match_amount
    // }
  },
  watch: {
    soccer_min_bet(newVal) {
      if(this.$helpers.convertNumber(newVal) > this.cs_min_bet_amount) {
        this.cs_min_bet_title = this.$t('ui.min_bet') + ' >= ' + this.$helpers.convertNumber(newVal)
      } else {
        this.cs_min_bet_title = this.$t('ui.min_bet') + ' >= ' + this.cs_min_bet_amount
      }
    },
    soccer_max_bet(newVal) {
      if(this.$helpers.convertNumber(newVal) < this.cs_max_bet_amount) {
        this.cs_max_bet_title = this.$t('ui.max_bet') + ' <= ' + this.$helpers.convertNumber(newVal)
      } else {
        this.cs_max_bet_title = this.$t('ui.max_bet') + ' <= ' + this.cs_max_bet_amount
      }
    },
    soccer_max_per_match(newVal) {
      if(this.$helpers.convertNumber(newVal) < this.cs_max_per_match_amount) {
        this.cs_max_per_match_title = this.$t('ui.max_per_match') + ' <= ' + this.$helpers.convertNumber(newVal)
      } else {
        this.cs_max_per_match_title = this.$t('ui.max_per_match') + ' <= ' + this.cs_max_per_match_amount
      }
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault()
      this.submit()
    },
    input_soccer_min_bet(e) {
      this.$v.soccer_min_bet.$model = e
      this.toggleAll()
    },
    input_soccer_max_bet(e) {
      this.$v.soccer_max_bet.$model = e
      this.toggleAll()
    },
    input_soccer_max_per_match(e) {
      this.$v.soccer_max_per_match.$model = e
      this.toggleAll()
    },
    toggleAll: function() {
      if(this.copyAllMin) {
        let soccerMin = this.$helpers.numberFormat(this.soccer_min_bet)
        this.$v.basketball_min_bet.$model = soccerMin
        this.$v.tennis_min_bet.$model = soccerMin
        this.$v.baseball_min_bet.$model = soccerMin
        this.$v.parlay_min_bet.$model = soccerMin
        this.$v.esports_min_bet.$model = soccerMin
        this.$v.others_min_bet.$model = soccerMin
        this.$v.cs_min_bet.$model = soccerMin
      }

      if(this.copyAllMax) {
        let soccerMax = this.$helpers.numberFormat(this.soccer_max_bet)
        this.$v.basketball_max_bet.$model = soccerMax
        this.$v.tennis_max_bet.$model = soccerMax
        this.$v.baseball_max_bet.$model = soccerMax
        this.$v.parlay_max_bet.$model = soccerMax
        this.$v.esports_max_bet.$model = soccerMax
        this.$v.others_max_bet.$model = soccerMax
        this.$v.cs_max_bet.$model = soccerMax
      }

      if(this.copyAllMaxPerMatch) {
        let soccerMaxPerMatch = this.$helpers.numberFormat(this.soccer_max_per_match)
        this.$v.basketball_max_per_match.$model = soccerMaxPerMatch
        this.$v.tennis_max_per_match.$model = soccerMaxPerMatch
        this.$v.baseball_max_per_match.$model = soccerMaxPerMatch
        this.$v.parlay_max_per_match.$model = soccerMaxPerMatch
        this.$v.esports_max_per_match.$model = soccerMaxPerMatch
        this.$v.others_max_per_match.$model = soccerMaxPerMatch
        this.$v.cs_max_per_match.$model = soccerMaxPerMatch
      }

    },
    getChildBetLimit: function() {
      $("input").prop("disabled", !this.$helpers.getVisible(this.editLimit))
      let account_id = this.accountId

      if(account_id) {
        this.$store
        .dispatch("user/getChildBetLimit", { account_id })
        .then(response => {
          this.$v.soccer_min_bet.$model = this.$helpers.numberFormat(response.data[6].min_bet)
          this.$v.soccer_max_bet.$model = this.$helpers.numberFormat(response.data[6].max_bet)
          this.$v.soccer_max_per_match.$model = this.$helpers.numberFormat(response.data[6].max_per_match)

          this.$v.basketball_min_bet.$model = this.$helpers.numberFormat(response.data[1].min_bet)
          this.$v.basketball_max_bet.$model = this.$helpers.numberFormat(response.data[1].max_bet)
          this.$v.basketball_max_per_match.$model = this.$helpers.numberFormat(response.data[1].max_per_match)

          this.$v.tennis_min_bet.$model = this.$helpers.numberFormat(response.data[7].min_bet)
          this.$v.tennis_max_bet.$model = this.$helpers.numberFormat(response.data[7].max_bet)
          this.$v.tennis_max_per_match.$model = this.$helpers.numberFormat(response.data[7].max_per_match)

          this.$v.baseball_min_bet.$model = this.$helpers.numberFormat(response.data[0].min_bet)
          this.$v.baseball_max_bet.$model = this.$helpers.numberFormat(response.data[0].max_bet)
          this.$v.baseball_max_per_match.$model = this.$helpers.numberFormat(response.data[0].max_per_match)

          this.$v.parlay_min_bet.$model = this.$helpers.numberFormat(response.data[5].min_bet)
          this.$v.parlay_max_bet.$model = this.$helpers.numberFormat(response.data[5].max_bet)
          this.$v.parlay_max_per_match.$model = this.$helpers.numberFormat(response.data[5].max_per_match)

          this.$v.esports_min_bet.$model = this.$helpers.numberFormat(response.data[3].min_bet)
          this.$v.esports_max_bet.$model = this.$helpers.numberFormat(response.data[3].max_bet)
          this.$v.esports_max_per_match.$model = this.$helpers.numberFormat(response.data[3].max_per_match)

          this.$v.others_min_bet.$model = this.$helpers.numberFormat(response.data[4].min_bet)
          this.$v.others_max_bet.$model = this.$helpers.numberFormat(response.data[4].max_bet)
          this.$v.others_max_per_match.$model = this.$helpers.numberFormat(response.data[4].max_per_match)

          this.$v.cs_min_bet.$model = this.$helpers.numberFormat(response.data[2].min_bet)
          this.$v.cs_max_bet.$model = this.$helpers.numberFormat(response.data[2].max_bet)
          this.$v.cs_max_per_match.$model = this.$helpers.numberFormat(response.data[2].max_per_match)
          $("input").prop("disabled", !this.$helpers.getVisible(this.editLimit))
        })
        .catch(response => {
          // console.log("child", response)
        });
      } else {
        this.cancel()
      }
    },
    submit: function() {
      // this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_bet_limit_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.updateBetLimitSB()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_bet_limit_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    updateBetLimitSB: function() {
      let account_id = this.accountId
      this.blJSON.soccer_min_bet = this.soccer_min_bet
      this.blJSON.soccer_max_bet = this.soccer_max_bet
      this.blJSON.soccer_max_per_match = this.soccer_max_per_match
      this.blJSON.basketball_min_bet = this.basketball_min_bet
      this.blJSON.basketball_max_bet = this.basketball_max_bet
      this.blJSON.basketball_max_per_match = this.basketball_max_per_match
      this.blJSON.tennis_min_bet = this.tennis_min_bet
      this.blJSON.tennis_max_bet = this.tennis_max_bet
      this.blJSON.tennis_max_per_match = this.tennis_max_per_match
      this.blJSON.baseball_min_bet = this.baseball_min_bet
      this.blJSON.baseball_max_bet = this.baseball_max_bet
      this.blJSON.baseball_max_per_match = this.baseball_max_per_match
      this.blJSON.parlay_min_bet = this.parlay_min_bet
      this.blJSON.parlay_max_bet = this.parlay_max_bet
      this.blJSON.parlay_max_per_match = this.parlay_max_per_match
      this.blJSON.esports_min_bet = this.esports_min_bet
      this.blJSON.esports_max_bet = this.esports_max_bet
      this.blJSON.esports_max_per_match = this.esports_max_per_match
      this.blJSON.others_min_bet = this.others_min_bet
      this.blJSON.others_max_bet = this.others_max_bet
      this.blJSON.others_max_per_match = this.others_max_per_match
      this.blJSON.cs_min_bet = this.cs_min_bet
      this.blJSON.cs_max_bet = this.cs_max_bet
      this.blJSON.cs_max_per_match = this.cs_max_per_match

      let bl = this.blJSON
      this.$store
        .dispatch("user/updateBetLimitSB", { account_id, bl })
        .then(response => {
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.update_account_bet_limit_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          // console.log("Failed:updateBetLimitSB", response)
          this.loading = false;
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.soccer_min_bet = "0"
      this.soccer_max_bet = "0"
      this.soccer_max_per_match = "0"
      this.basketball_min_bet = "0"
      this.basketball_max_bet = "0"
      this.basketball_max_per_match = "0"
      this.tennis_min_bet = "0"
      this.tennis_max_bet = "0"
      this.tennis_max_per_match = "0"
      this.baseball_min_bet = "0"
      this.baseball_max_bet = "0"
      this.baseball_max_per_match = "0"
      this.parlay_min_bet = "0"
      this.parlay_max_bet = "0"
      this.parlay_max_per_match = "0"
      this.esports_min_bet = "0"
      this.esports_max_bet = "0"
      this.esports_max_per_match = "0"
      this.others_min_bet = "0"
      this.others_max_bet = "0"
      this.others_max_per_match = "0"
      this.cs_min_bet = "0"
      this.cs_max_bet = "0"
      this.cs_max_per_match = "0"
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
        this.$helpers.getBetLimit()
        this.getChildBetLimit()
      });
    },
    cancel: function() {
      // this.$emit("clicked")
      this.$refs.updateBLSB.hide()
    }
  }
};
</script>

